import ModelMarshaller from './ModelMarshaller';
import Article from './Article';
import PriceItemMashaller from './PriceItemMarshaller';
import PriceItem from './PriceItem';

export default class ArticleMarshaller extends ModelMarshaller<Article> {
   
    
    toJSON() {
        if (this.data instanceof Article) {

            let priceItems = {}

            this.data.$prices.forEach(priceItem => {
                let marshaller = new PriceItemMashaller(priceItem)
                priceItems = {
                    ...marshaller.toJSON()
                }
            });

            return {
                ingredients: this.data.$description,
                number: this.data.$number,
                title: this.data.$name,
                icon: this.data.$icon,
                prices: priceItems,
                starorder: this.data.$isStarorder
            }
        }
        return this.data
    }    
    
    toModel(): Article {
        if (this.data instanceof Article) {
            return this.data
        }
        let priceItems: Array<PriceItem> = [];
        Object.getOwnPropertyNames(this.data.prices).forEach(element => {
            priceItems.push(new PriceItem(element,this.data.prices[element]))
        });
        return new Article(this.data.title,priceItems,this.data.starorder,this.data.number,this.data.icon,this.data.ingredients)
    }


}